import React, { useState, useEffect, useContext, useRef } from "react";
import MenuButton from "../MenuButton/MenuButton";
import { useFormik } from "formik";
import { staffAdvances } from "../schemas";
import UserServices from "../../UserServices/UserServices";
import Swal from "sweetalert2/dist/sweetalert2.js";
import moment from "moment";
import { NoteState } from "../../context/notes/NoteState";
import { viewFines } from "../schemas";
import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import useSortableData from "../../hooks/useSortableData";
import useTable from "../../hooks/useTable";
import { toast } from "react-toastify";
import $ from "jquery";
import jsPDF from "jspdf";

const ManageStaffAdvances = () => {
  const [names, setNames] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [currentPage, setCurrentPage] = useState(1);
  const date = new Date();
  const futureDate = date.getDate();
  date.setDate(futureDate);
  const defaultValue = date.toLocaleDateString("en-CA");
  let eDate = moment(defaultValue).format("YYYY-MM-DD");
  const { state } = useContext(NoteState);
  const { branch_id } = state;
  const [paymentMethodsSplit, setPaymentMethodsSplit] = useState([]);
  // eslint-disable-next-line
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [bank, setBank] = useState([]);
  const year = new Date().getFullYear();
  const [myData, setMyData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [advanceTime, setAdvanceTime] = useState();
  const [limit, setLimit] = useState("25");
  const [totalResults, setTotalResults] = useState("0");
  const [totalPages, setTotalPages] = useState("1");
  const [exportLink, setExportLink] = useState("");
  const month = date.getMonth();
  const monthString = (parseInt(month) + 1).toString();
  let sDate = moment().startOf("month").format("YYYY-MM-DD");
  // update
  const [fname, setFname] = useState("");
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const [recordDate, setRecordDate] = useState("");
  const [transaction, setTransaction] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [bankAccount, setBankAccount] = useState("");
  const [recordMonth, setRecordMonth] = useState("");
  const [recordId, setRecordId] = useState("");
  const [branch, setBranch] = useState("");

  var clickEvent = $.Event("click");

  const closeButtonRef = useRef(null);
  const getUser = async (id) => {
    setLoading(true);
    try {
      const responce = await UserServices.getStaffFinesInfo(id);
      if (responce.status === 200) {
        let data = responce.data.data.data;
        data.map((values) => {
          setFname(values.user_id);
          setAmount(values.amount);
          setReason(values.reason);
          setRecordDate(values.occurrence_date);
          setTransaction(values.transaction_type);
          setPaymentMethod(values.payment_type_id);
          setRecordMonth(values.return_month);
          setBankAccount(values.bank_account_id);
          setBranch(values.branch_id);
          setRecordId(values.id);
          return null;
        });
        $("#membership").trigger(clickEvent);
        setLoading(false);
      }
    } catch (err) {
      if (err.response.status === 404) {
        setLoading(false);
      } else {
        setLoading(false);
      }
    }
  };
  const getUsers = async (page, limit) => {
    setLoading(true);
    setCurrentPage(page);
    let pageNo = page;

    let newLimit = limit;
    setLimit(newLimit);
    try {
      const responce = await UserServices.getStaffAdvanceDataByTime(
        branch_id,
        "1",
        newLimit,
        pageNo,
        values
      );
      let myDataarr;

      if (responce.status === 200) {
        setExportLink(
          process.env.REACT_APP_API_Link +
            "/users-finance/ExportUsersFinance?category=Advance&start_date=" +
            values.startdate +
            "&end_date=" +
            values.enddate +
            "&branch_id=" +
            branch_id
        );
        myDataarr = responce.data.data.data;
        const res = myDataarr;
        const results = [];

        res.map((values) => {
          results.push({
            id: values.id,
            user_id: values.user_id,
            user_fname: values.user_fname,
            user_lname: values.user_lname,
            amount: values.amount,
            transaction_type: values.transaction_type,
            payment_method: values.payment_method,
            reason: values.reason,
            occurrence_date: values.occurrence_date,
            return_month: values.return_month,
          });
          return null;
        });

        setMyData([...results]);
        setLimit(responce.data.data.per_page);
        setTotalResults(responce.data.totalRecord);
        setTotalPages(responce.data.totalPages);
        setCurrentPage(responce.data.data.current_page);
        setLoading(false);
      }
    } catch (err) {
      if (err.response.status === 404) {
        setTotalResults("0");
        setTotalPages("1");
        setExportLink();
        setMyData([]);
        setLoading(false);
      } else {
        setLoading(false);
        setExportLink();
      }
    }
  };
  const staffNames = async () => {
    // setCurrentPage();
    try {
      const responce = await UserServices.staffName(branch_id);
      const res = responce.data.data;
      const results = [];
      res.map((values) => {
        results.push({
          id: values.id,
          name: values.first_name + " " + values.last_name,
        });
        return null;
      });
      setNames([{ name: "Select Names", id: "" }, ...results]);
    } catch (err) {
      console.log(err);
    }
  };
  const getPaymentMethodinitial = async () => {
    try {
      const responce = await UserServices.paymentNames();
      const res = responce.data.data;
      const results = res.filter((value) => value.id !== 81 && value.id !== 82); // Filter out payment method with id 81
      setPaymentMethods([...results]);
      setPaymentMethodsSplit([...results]);
    } catch (err) {
      console.log(err);

      setPaymentMethods([{ name: "No Payment Method Found", id: "" }]);
      setPaymentMethodsSplit([{ name: "No Payment Method Found", id: "" }]);
    }
  };
  const bankDetails = async () => {
    try {
      const responce = await UserServices.bankList(branch_id);
      const res = responce.data.data;
      const results = [];
      res.map((value) => {
        results.push({
          id: value.id,
          bank_name: value.bank_name,
          account_no: value.account_no,
        });
        return null;
      });
      setBank([{ bank_name: "Select Bank", id: "" }, ...results]);
    } catch (err) {
      console.log(err);
      setBank([{ bank_name: "No Bank Found", id: "" }]);
    }
  };
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    getUsers(currentPage, limit);
    staffNames();
    getPaymentMethodinitial(branch_id);
    bankDetails();
  }, []);

  const deleteRecord = async (stafffine_id) => {
    try {
      const responce = await UserServices.deleteStaffFines(stafffine_id);

      if (responce.status === 204) {
        toast.error("Deleted Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        getUsers(currentPage, limit);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const delFine = (stafffine_id) => {
    deleteRecord(stafffine_id);
  };

  const changeAdvanceTime = (e) => {
    let monthCode = e;
    setAdvanceTime(monthCode);

    const getFineTimeData = async () => {
      setLoading(true);
      if (!monthCode) {
        setLoading(false);
        return;
      }
      const month = parseInt(monthCode, 10); // Parse the month code as an integer

      // Create a new Date object for the next month
      const endDate = new Date(year, month, 0);

      // Extract the day from the end date
      const endDay = endDate.getDate();

      setValues({
        startdate: year + "-" + monthCode + "-01",
        enddate: year + "-" + monthCode + "-" + endDay,
      });

      try {
        const responce = await UserServices.getStaffAdvanceDataByMonth(
          branch_id,
          "1",
          "10",
          1,
          year + "-" + monthCode + "-01",
          year + "-" + monthCode + "-" + endDay
        );
        let myDataarr;

        if (responce.status === 200) {
          setExportLink(
            process.env.REACT_APP_API_Link +
              "/users-finance/ExportUsersFinance?&start_date=" +
              year +
              "-" +
              monthCode +
              "-01&end_date=" +
              year +
              "-" +
              monthCode +
              "-" +
              endDay +
              "&category=Advance&branch_id=" +
              branch_id
          );
          myDataarr = responce.data.data.data;
          const res = myDataarr;
          const results = [];

          res.map((values) => {
            results.push({
              id: values.id,
              user_fname: values.user_fname,
              user_lname: values.user_lname,
              amount: values.amount,
              transaction_type: values.transaction_type,
              payment_method: values.payment_method,
              reason: values.reason,
              occurrence_date: values.occurrence_date,
              return_month: values.return_month,
            });
            return null;
          });

          setMyData([...results]);
          setTotalResults(responce.data.totalRecord);
          setLimit(responce.data.data.per_page);
          setTotalPages(responce.data.totalPages);
          setCurrentPage(responce.data.data.current_page);
          setLoading(false);
        }
      } catch (err) {
        if (err.response.status === 404) {
          setExportLink();
          console.log(err);
          setTotalResults("0");
          setTotalPages("1");
          setMyData([]);
          setLoading(false);
          // setError("No record  found");
        } else {
          setLoading(false);
        }
      }
    };
    getFineTimeData();
  };
  const findAdvance = async (values) => {
    if (Date.parse(values.startdate) <= Date.parse(values.enddate)) {
      if (Date.parse(values.enddate) >= Date.parse(values.startdate)) {
        setLoading(true);
        try {
          const response = await UserServices.getStaffAdvanceDataByYear(
            branch_id,
            "1",
            limit,
            1,
            values
          );

          let myDataarr;

          if (response.status === 200) {
            setExportLink(
              process.env.REACT_APP_API_Link +
                "/users-finance/ExportUsersFinance?&start_date=" +
                values.startdate +
                "&end_date=" +
                values.enddate +
                "&category=Advance&branch_id=" +
                branch_id
            );
            myDataarr = response.data.data.data;
            const res = myDataarr;
            const results = [];

            res.map((values) => {
              results.push({
                id: values.id,
                user_fname: values.user_fname,
                user_lname: values.user_lname,
                amount: values.amount,
                transaction_type: values.transaction_type,
                payment_method: values.payment_method,
                reason: values.reason,
                occurrence_date: values.occurrence_date,
                return_month: values.return_month,
              });
              return null;
            });

            setMyData([...results]);
            setTotalResults(response.data.totalRecord);
            setTotalPages(response.data.totalPages);
            setCurrentPage(response.data.data.current_page);
            setLoading(false);
          }
        } catch (err) {
          if (err.response.status === 404) {
            setExportLink();
            setTotalResults("0");
            setTotalPages("1");
            setMyData([]);
            setLoading(false);
          } else {
            setLoading(false);
          }
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Start date should be less then end date!",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "End date should be greater then start date!",
      });
    }
  };
  const addAdvance = async (addAdvanceValues, action) => {
    try {
      setLoading(true);
      const response = await UserServices.addStaffAdvances(
        branch_id,
        addAdvanceValues,
        "Advance"
      );
      if (response.status === 201) {
        setLoading(false);
        toast.success("Added Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        action.resetForm();
        getUsers(currentPage, limit);
      }
    } catch (err) {
      if (err.response?.status === 422) {
      } else if (err.response.status === 500) {
        // toast.error("Unproccessable content!", { position: "top-center" });
      } else if (err.response.status === 400) {
        // toast.error("Unproccessable content!", { position: "top-center" });
      }
    }
  };
  const addAdvanceinitialValues = {
    occurrence_date: eDate,
    name: "",
    amount: "",
    transaction_type: "",
    payment_type_id: "",
    reason: "N/A",
    cheque_no: "",
    return_month: "",
    bank_account_id: "",
  };
  const initialValues = {
    startdate: sDate,
    enddate: eDate,
  };
  const {
    values: addAdvanceValues,
    errors: addAdvanceErrors,
    touched: addAdvanceTouched,
    handleBlur: addAdvanceHandleBlur,
    handleChange: addAdvanceHandleChange,
    handleSubmit: addAdvanceHandleSubmit,
  } = useFormik({
    initialValues: addAdvanceinitialValues,
    validationSchema: staffAdvances,
    onSubmit: (addAdvanceValues, action) => {
      addAdvance(addAdvanceValues, action);
    },
  });
  const {
    values,
    errors,
    touched,
    setValues,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: viewFines,
    onSubmit: (values) => {
      findAdvance(values);
    },
  });
  const generatePdf = (table) => {
    const doc = new jsPDF("p", "mm", "letter");

    // Loop through all the tables in the section and add them to the PDF

    // Add a new page for each table (skip first table as it is already on the first page)
    const captionText = table.getAttribute("data-caption");
    // Add the table caption as regular text above the table
    doc.text(  captionText, 10, 10);
    const tableOptions = {
      headStyles: { fillColor: [232, 0, 43], textColor: 255 },
      styles: { fontSize: 5 }, // Adjust the font size here to fit the table content
    };
    doc.autoTable({
      html: table,
      ...tableOptions,
    });

    doc.save("Staff_Advances.pdf");
  };

  const Table = ({ data, rowsPerPage }) => {
    const { slice } = useTable(data, 1, rowsPerPage);
    const { items, requestSort, sortConfig } = useSortableData(slice);

    const getClassNamesFor = (name) => {
      if (!sortConfig) {
        return;
      }
      return sortConfig.key === name ? sortConfig.direction : undefined;
    };

    return (
      <>
        <div className="table-responsive custom-table-1 mt-3">
          <table
            className="table table-striped table-borderless table-style-1"
            id="report-POS"
            data-caption="Staff Advances"
          >
            <thead>
              <tr>
                <th scope="col" className="no_sort">
                  Sr#
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("user_fname")}
                  className={getClassNamesFor("user_fname")}
                >
                  Name
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("amount")}
                  className={getClassNamesFor("amount")}
                >
                  Amount
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("return_month")}
                  className={getClassNamesFor("return_month")}
                >
                  Return Month
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("transaction_type")}
                  className={getClassNamesFor("transaction_type")}
                >
                  Transaction Type
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("payment_method")}
                  className={getClassNamesFor("payment_method")}
                >
                  Payment Method
                </th>

                <th scope="col" className="no_sort">
                  Reason
                </th>

                <th scope="col" className="no_sort">
                  Date
                </th>

                <th scope="col" className="no_sort">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {items.length ? (
                items.map((el, index) => (
                  <tr key={index}>
                    <td>
                      {currentPage === 1
                        ? index + 1
                        : (currentPage - 1) * limit + index + 1}
                    </td>
                    <td>
                      <Link to={"/staff-home/" + el.user_id}>
                        {el.user_fname} {el.user_lname}
                      </Link>
                    </td>
                    <td>
                      <CurrencyFormat
                        value={el.amount}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"Rs "}
                        suffix={"/-"}
                        thousandSpacing={"3"}
                      />
                    </td>
                    <td>{moment(el.return_month).format("MMMM")}</td>
                    <td>{el.transaction_type}</td>
                    <td>{el.payment_method}</td>
                    <td>{el.reason}</td>
                    <td>{moment(el.occurrence_date).format("DD-MM-YYYY")}</td>
                    <td>
                      <button
                        onClick={() => {
                          getUser(el.id);
                        }}
                        className="text-warning border-0 bg-transparent"
                      >
                        <i className="bi bi-pencil-fill" />
                      </button>
                      <button
                        type="button"
                        className="text-danger custom-button-image"
                        onClick={() => delFine(el.id)}
                      >
                        <i className="bi bi-trash-fill" />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="14" className="text-center text-capitalize">
                    No record found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="">
            {totalResults > limit && totalPages > 1 ? (
              <Pagination
                activePage={currentPage}
                itemsCountPerPage={parseInt(limit)}
                totalItemsCount={totalResults}
                onChange={(e) => {
                  getUsers(e, limit);
                }}
                pageRangeDisplayed={8}
                itemClass="page-item"
                linkClass="page-link"
                firstPageText="First Page"
                lastPageText="Last Page"
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </>
    );
  };
  const UpdateAdvance = async (updateValues) => {
    setLoading(true);

    try {
      const response = await UserServices.UpdateStaffAdvances(
        updateValues,
        recordId,
        "Advance"
      );
      if (response.status === 204) {
        setLoading(false);
        toast.success("Updated Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setLoading(false);
        getUsers(currentPage, limit);
        // Trigger the close button click event
        closeButtonRef.current.click();
      }
    } catch (err) {
      if (err.response.status === 422) {
        toast.error("Some data is missing", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        setLoading(false);
      } else {
        toast.error("Some thing went wronge !", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setLoading(false);
      }
    }
  };
  const updateinitialValues = {
    occurrence_date: recordDate,
    user_id: fname,
    amount: amount,
    transaction_type: transaction,
    payment_type_id: paymentMethod,
    reason: reason,
    return_month: recordMonth,
    bank_account_id: bankAccount,
    branch_id: branch,
  };

  //....................................................................................................................................
  const {
    values: updateValues,
    errors: updateErrors,
    touched: updateTouched,
    handleBlur: updateHandleBlur,
    handleChange: updateHandleChange,
    handleSubmit: updateHandleSubmit,
  } = useFormik({
    enableReinitialize: true,
    initialValues: updateinitialValues,
    validationSchema: staffAdvances,
    onSubmit: (updateValues) => {
      UpdateAdvance(updateValues);
    },
  });
  return (
    <>
      <div className="wrapper">
        <main className="page-content customer-contnent">
          <div className="site-main-design">
            <MenuButton />
            <div className="card">
              <div className="card-header py-3">
                <h5 className="mb-0 font-20">Manage Staff Advances</h5>
              </div>
              <div className="card-body">
                <p>
                  <i
                    className="bi bi-exclamation-lg text-danger"
                    aria-hidden="true"
                  />
                  The Fields With <strong className="text-danger">*</strong>{" "}
                  Must Required Or Fill.
                </p>
                <form
                  className="row g-3 trainee-add"
                  onSubmit={addAdvanceHandleSubmit}
                >
                  <div className="col-12 col-md-4">
                    <div className="form-group custom-group">
                      <label className="form-label">Advance Date</label>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="15-02-2022"
                        name="occurrence_date"
                        value={addAdvanceValues.occurrence_date}
                        onChange={addAdvanceHandleChange}
                        onBlur={addAdvanceHandleBlur}
                      />
                      {addAdvanceErrors.occurrence_date &&
                      addAdvanceTouched.occurrence_date ? (
                        <p className="text-danger">
                          {addAdvanceErrors.occurrence_date}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group custom-group">
                      <label className="form-label">
                        Name <span className="text-danger">*</span>
                      </label>
                      {names ? (
                        <select
                          className="form-select"
                          name="user_id"
                          value={addAdvanceValues.user_id}
                          onChange={(e) => {
                            addAdvanceHandleChange(e);
                          }}
                          onBlur={addAdvanceHandleBlur}
                        >
                          {names.map((el, index) => {
                            return (
                              <option key={index} value={el.id}>
                                {el.name}
                              </option>
                            );
                          })}
                        </select>
                      ) : null}
                      {addAdvanceErrors.user_id && addAdvanceTouched.user_id ? (
                        <p className="text-danger">
                          {addAdvanceErrors.user_id}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group custom-group">
                      <label className="form-label">
                        Amount <span className="text-danger">*</span>
                      </label>
                      <input
                        onWheel={(e) => e.target.blur()}
                        type="number"
                        className="form-control"
                        placeholder="Amount "
                        min={0}
                        name="amount"
                        value={addAdvanceValues.amount}
                        onChange={addAdvanceHandleChange}
                        onBlur={addAdvanceHandleBlur}
                      />
                      {addAdvanceErrors.amount && addAdvanceTouched.amount ? (
                        <p className="text-danger">{addAdvanceErrors.amount}</p>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="form-group custom-group">
                      <label className="form-label">
                        Return Month <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        name="return_month"
                        value={
                          addAdvanceinitialValues.return_month.split("-")[1]
                        } // Extract the month value from return_month
                        onChange={(e) => {
                          const selectedMonth = e.target.value;
                          const selectedMonthWithYear = `${year}-${selectedMonth}-01`;
                          addAdvanceHandleChange({
                            target: {
                              name: "return_month",
                              value: selectedMonthWithYear,
                            },
                          });
                        }}
                        onBlur={addAdvanceHandleBlur}
                      >
                        <option value="-1">Select Month</option>
                        <option value="01">January</option>
                        <option value="02">February</option>
                        <option value="03">March</option>
                        <option value="04">April</option>
                        <option value="05">May</option>
                        <option value="06">June</option>
                        <option value="07">July</option>
                        <option value="08">August</option>
                        <option value="09">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select>
                      {addAdvanceErrors.return_month &&
                      addAdvanceTouched.return_month ? (
                        <p className="text-danger">
                          {addAdvanceErrors.return_month}
                        </p>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-12 col-md-4">
                    <div className="form-group custom-group">
                      <label className="form-label">
                        Transaction<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        name="transaction_type"
                        value={addAdvanceValues.transaction_type || ""}
                        onChange={(e) => {
                          addAdvanceHandleChange(e);
                        }}
                        onBlur={addAdvanceHandleBlur}
                      >
                        <option value="-1">Select Transaction</option>
                        <option value="Bank Account">Bank Account</option>
                        <option value="Sales Counter">Sales Counter</option>
                        <option value="Office Counter">Office Counter</option>
                        <option value="Personal">Personal</option>
                      </select>
                      {addAdvanceErrors.transaction_type &&
                      addAdvanceTouched.transaction_type ? (
                        <p className="text-danger">
                          {addAdvanceErrors.transaction_type}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  {addAdvanceValues.transaction_type === "Bank Account" ? (
                    <div className="col-12 col-md-4">
                      <div className="form-group custom-group">
                        <label className="form-label">
                          Bank Details<span className="text-danger">*</span>
                        </label>
                        {bank ? (
                          <select
                            className="form-select"
                            name="bank_account_id"
                            value={addAdvanceValues.bank_account_id || ""}
                            onChange={(e) => {
                              addAdvanceHandleChange(e);
                            }}
                            onBlur={addAdvanceHandleBlur}
                          >
                            {bank.map((el, index) => {
                              return (
                                <option key={index} value={el.id}>
                                  {el.bank_name} {el.account_no}
                                </option>
                              );
                            })}
                          </select>
                        ) : null}
                        {addAdvanceErrors.bank_account_id &&
                        addAdvanceTouched.bank_account_id ? (
                          <p className="text-danger">
                            {addAdvanceErrors.bank_account_id}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  ) : null}
                  <div className="col-12 col-md-4">
                    <div className="form-group custom-group">
                      <label className="form-label">Payment Method</label>
                      <span className="text-danger">*</span>
                      {paymentMethodsSplit.length ? (
                        <select
                          className="form-select"
                          name="payment_type_id"
                          value={addAdvanceValues.payment_type_id}
                          onChange={addAdvanceHandleChange}
                          onBlur={addAdvanceHandleBlur}
                        >
                          <option>Select Payment Method</option>
                          {paymentMethodsSplit.map((el, index) => {
                            return (
                              <option key={index} value={el.id}>
                                {el.name}
                              </option>
                            );
                          })}
                        </select>
                      ) : (
                        <select
                          className="form-select"
                          name="payment_type_id"
                          value={addAdvanceValues.payment_type_id}
                          onChange={(e) => {
                            addAdvanceHandleChange(e);
                          }}
                          onBlur={addAdvanceHandleBlur}
                        >
                          <option>Select Payment Method</option>
                        </select>
                      )}
                      {addAdvanceErrors.payment_type_id &&
                      addAdvanceTouched.payment_type_id ? (
                        <p className="text-danger">
                          {addAdvanceErrors.payment_type_id}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  {addAdvanceValues.payment_type_id === "32" ? (
                    <div className="col-12 col-md-4">
                      <div className="form-group custom-group">
                        <div className="form-group custom-group">
                          <label htmlFor="form-label" className="form-label">
                            Cheque Number <span className="text-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="cheque_no"
                            value={addAdvanceValues.cheque_no}
                            onChange={(e) => {
                              addAdvanceHandleChange(e);
                            }}
                            onBlur={addAdvanceHandleBlur}
                          />

                          {addAdvanceErrors.cheque_no &&
                          addAdvanceTouched.cheque_no ? (
                            <p className="text-danger">
                              {addAdvanceErrors.cheque_no}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="col-12 col-md-4">
                    <div className="form-group custom-group">
                      <label className="form-label">
                        Reason <span className="text-danger">*</span>
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder="Reason"
                        name="reason"
                        value={addAdvanceValues.reason}
                        onChange={addAdvanceHandleChange}
                        onBlur={addAdvanceHandleBlur}
                      />
                      {addAdvanceErrors.reason && addAdvanceTouched.reason ? (
                        <p className="text-danger">{addAdvanceErrors.reason}</p>
                      ) : null}
                    </div>
                  </div>
                  <div className="clearfix" />
                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn-primary px-5 rounded-0 mb-1"
                    >
                      Add Advance
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="card">
              <div className="card-header py-3">
                <h5 className="mb-0 font-20">Advances</h5>
              </div>
              <div className="card-body">
                <form className="mb-3" onSubmit={handleSubmit}>
                  <div className="row d-flex">
                    <div className="col-md-2 mt-3">
                      <label className="form-label">Filter By Month</label>
                      <select
                        className="form-select"
                        onChange={(e) => changeAdvanceTime(e.target.value)}
                        defaultValue={advanceTime}
                      >
                        <option value="">Select Month</option>
                        <option value="01">January</option>
                        <option value="02">February</option>
                        <option value="03">March</option>
                        <option value="04">April</option>
                        <option value="05">May</option>
                        <option value="06">June</option>
                        <option value="07">July</option>
                        <option value="08">August</option>
                        <option value="09">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select>
                    </div>
                    <div className="col-md-2 mt-3">
                      <label className="form-label">From</label>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="date"
                        name="startdate"
                        value={values.startdate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.startdate && touched.startdate ? (
                        <p className="text-danger">{errors.startdate}</p>
                      ) : null}
                    </div>
                    <div className="col-md-2 mt-3">
                      <label className="form-label">To</label>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="date"
                        name="enddate"
                        value={values.enddate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.enddate && touched.enddate ? (
                        <p className="text-danger">{errors.enddate}</p>
                      ) : null}
                    </div>
                    <div className="col-12 col-md-1   ">
                      <button
                        type="submit"
                        className="btn btn-primary d-inline-block btn-sm mt-5"
                        onChange={() => findAdvance(values)}
                      >
                        Generate
                      </button>
                    </div>
                    {/* {totalResults > limit ? ( */}
                    <div className="col-md-1 col-lg-1 mt-5 ms-auto">
                      <div className="input-group">
                        <select
                          className="form-select"
                          value={limit}
                          onChange={(e) => getUsers("1", e.target.value)}
                        >
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="250">250</option>
                          <option value="500">500</option>
                        </select>
                      </div>
                    </div>
                    {/* ) : null} */}
                    <div className=" col-md-4 text-end mt-5">
                      <button
                        className="btn btn-primary mx-2 file-download"
                        onClick={() => {
                          generatePdf(document.getElementById("report-POS"));
                        }}
                      >
                        <i className="bi bi-file-earmark-pdf"></i> PDF
                      </button>
                      <a
                        href={exportLink}
                        rel="noreferrer"
                        // target="_blank"
                        className="btn btn-primary mx-2 file-download"
                      >
                        <i className="bi bi-download" /> Excel
                      </a>
                    </div>
                  </div>
                </form>
                <Table data={myData} rowsPerPage={limit} />
              </div>
            </div>
            <div className="d-flex">
              <div className="ms-auto d-flex">
                <div className="mt-1">
                  <h5>Grand Total:</h5>
                </div>
                <div className="ms-2  fs-5">
                  <CurrencyFormat
                    value={myData.reduce((a, v) => (a = a + v.amount), 0)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"Rs "}
                    suffix={"/-"}
                    thousandSpacing={"3"}
                  />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      {/* ......Hidden Button....... */}
      <button
        className="btn btn-primary w-100 d-none"
        type="button"
        id="membership"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdrop"
      ></button>
      {/* Modal */}
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="staticBackdropLabel">
                Update Staff Advance
              </h1>
              <button
                type="button"
                className="btn-close me-3  mb-3"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeButtonRef}
              >
                <i className="bi bi-x-lg text-dark fs-4"></i>
              </button>
            </div>
            <div className="modal-body">
              <form
                className="row g-3 trainee-add"
                onSubmit={updateHandleSubmit}
              >
                <div className="col-12 col-md-4">
                  <div className="form-group custom-group">
                    <label className="form-label">Advance Date</label>
                    <input
                      type="date"
                      className="form-control"
                      placeholder="15-02-2022"
                      name="occurrence_date"
                      value={updateValues.occurrence_date}
                      onChange={updateHandleChange}
                      onBlur={updateHandleBlur}
                    />
                    {updateErrors.occurrence_date &&
                    updateTouched.occurrence_date ? (
                      <p className="text-danger">
                        {updateErrors.occurrence_date}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="form-group custom-group">
                    <label className="form-label">
                      Name <span className="text-danger">*</span>
                    </label>
                    {names ? (
                      <select
                        className="form-select"
                        name="user_id"
                        value={updateValues.user_id}
                        onChange={(e) => {
                          updateHandleChange(e);
                        }}
                        onBlur={updateHandleBlur}
                      >
                        {names.map((el, index) => {
                          return (
                            <option key={index} value={el.id}>
                              {el.name}
                            </option>
                          );
                        })}
                      </select>
                    ) : null}
                    {updateErrors.user_id && updateTouched.user_id ? (
                      <p className="text-danger">{updateErrors.user_id}</p>
                    ) : null}
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="form-group custom-group">
                    <label className="form-label">
                      Amount <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Amount "
                      name="amount"
                      value={updateValues.amount}
                      onChange={updateHandleChange}
                      onBlur={updateHandleBlur}
                    />
                    {updateErrors.amount && updateTouched.amount ? (
                      <p className="text-danger">{updateErrors.amount}</p>
                    ) : null}
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="form-group custom-group">
                    <label className="form-label">
                      Return Month <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      name="return_month"
                      value={updateValues.return_month.split("-")[1]} // Extract the month value from return_month
                      onChange={(e) => {
                        const selectedMonth = e.target.value;
                        const selectedMonthWithYear = `${year}-${selectedMonth}-01`;
                        updateHandleChange({
                          target: {
                            name: "return_month",
                            value: selectedMonthWithYear,
                          },
                        });
                      }}
                      onBlur={updateHandleBlur}
                    >
                      <option value="-1">Select Month</option>
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                    {updateErrors.return_month && updateTouched.return_month ? (
                      <p className="text-danger">{updateErrors.return_month}</p>
                    ) : null}
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="form-group custom-group">
                    <label className="form-label">
                      Transaction<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      name="transaction_type"
                      value={updateValues.transaction_type || ""}
                      onChange={(e) => {
                        updateHandleChange(e);
                      }}
                      onBlur={updateHandleBlur}
                    >
                      <option value="-1">Select Transaction</option>
                      <option value="Bank Account">Bank Account</option>
                      <option value="Sales Counter">Sales Counter</option>
                      <option value="Office Counter">Office Counter</option>
                      <option value="Personal">Personal</option>
                    </select>
                    {updateErrors.transaction_type &&
                    updateTouched.transaction_type ? (
                      <p className="text-danger">
                        {updateErrors.transaction_type}
                      </p>
                    ) : null}
                  </div>
                </div>
                {updateValues.transaction_type === "Bank Account" ? (
                  <div className="col-12 col-md-4">
                    <div className="form-group custom-group">
                      <label className="form-label">
                        Bank Details<span className="text-danger">*</span>
                      </label>
                      {bank ? (
                        <select
                          className="form-select"
                          name="bank_account_id"
                          value={updateValues.bank_account_id || ""}
                          onChange={(e) => {
                            updateHandleChange(e);
                          }}
                          onBlur={updateHandleBlur}
                        >
                          {bank.map((el, index) => {
                            return (
                              <option key={index} value={el.id}>
                                {el.bank_name} {el.account_no}
                              </option>
                            );
                          })}
                        </select>
                      ) : null}
                      {updateErrors.bank_account_id &&
                      updateTouched.bank_account_id ? (
                        <p className="text-danger">
                          {updateErrors.bank_account_id}
                        </p>
                      ) : null}
                    </div>
                  </div>
                ) : null}
                <div className="col-12 col-md-4">
                  <div className="form-group custom-group">
                    <label className="form-label">Payment Method</label>
                    <span className="text-danger">*</span>
                    {paymentMethodsSplit.length ? (
                      <select
                        className="form-select"
                        name="payment_type_id"
                        value={updateValues.payment_type_id}
                        onChange={updateHandleChange}
                        onBlur={updateHandleBlur}
                      >
                        <option>Select Payment Method</option>
                        {paymentMethodsSplit.map((el, index) => {
                          return (
                            <option key={index} value={el.id}>
                              {el.name}
                            </option>
                          );
                        })}
                      </select>
                    ) : (
                      <select
                        className="form-select"
                        name="payment_type_id"
                        value={updateValues.payment_type_id}
                        onChange={(e) => {
                          updateHandleChange(e);
                        }}
                        onBlur={updateHandleBlur}
                      >
                        <option>Select Payment Method</option>
                      </select>
                    )}
                    {updateErrors.payment_type_id &&
                    updateTouched.payment_type_id ? (
                      <p className="text-danger">
                        {updateErrors.payment_type_id}
                      </p>
                    ) : null}
                  </div>
                </div>
                {updateValues.payment_type_id === "32" ||
                updateValues.payment_type_id === 32 ? (
                  <div className="col-12 col-md-4">
                    <div className="form-group custom-group">
                      <div className="form-group custom-group">
                        <label htmlFor="form-label" className="form-label">
                          Cheque Number <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="cheque_no"
                          value={updateValues.cheque_no}
                          onChange={(e) => {
                            updateHandleChange(e);
                          }}
                          onBlur={updateHandleBlur}
                        />

                        {updateErrors.cheque_no && updateTouched.cheque_no ? (
                          <p className="text-danger">
                            {updateErrors.cheque_no}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="col-12 col-md-4">
                  <div className="form-group custom-group">
                    <label className="form-label">
                      Reason <span className="text-danger">*</span>
                    </label>
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder="Reason"
                      name="reason"
                      value={updateValues.reason}
                      onChange={updateHandleChange}
                      onBlur={updateHandleBlur}
                    />
                    {updateErrors.reason && updateTouched.reason ? (
                      <p className="text-danger">{updateErrors.reason}</p>
                    ) : null}
                  </div>
                </div>
                <div className="clearfix" />
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary px-5 rounded-0 mb-1"
                  >
                    Update Advance
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </>
  );
};

export default ManageStaffAdvances;
